export const status = (parentVue) => {
    return {
        sortable: false,
    };
};
export const scheme = (parentVue) => {
    return {
        sortable: false,
        render: (h, params) => {
            return h("Tag",
                params.row.scheme
            );
        }
    };
};



// WEBPACK FOOTER //
// ./src/view/WafEvent/fields.js